import { ObjetKStatus, enumValue } from '@siclop/kstone-vue'
import { SchedulingPhase, CrudType, ComplexityLevel } from '../enums'

export class EstimationScale extends ObjetKStatus {
  code: string = ''
  label: string = ''

  // Creation days (by complexity)
  creationSimpleDays: number = 1
  creationMediumDays: number = 3
  creationComplexDays: number = 5

  // Modification days (by complexity)
  modificationSimpleDays: number = 0.5
  modificationMediumDays: number = 1.5
  modificationComplexDays: number = 3

  // Deletion days (by complexity)
  deletionSimpleDays: number = 0.25
  deletionMediumDays: number = 0.5
  deletionComplexDays: number = 1

  typicalPercentage: number = 0
  order: number = 0
  color?: string
  description?: string
  isActive: boolean = true
  defaultHourlyRate: number = 0
  /** Abaque de facturation par défaut (repli du taux des activités) ; un seul à la fois, contrôlé par l'API. */
  isDefaultBillingScale: boolean = false
  schedulingPhase: SchedulingPhase = SchedulingPhase.Development

  constructor(data?: Partial<EstimationScale>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      // Creation days
      this.creationSimpleDays = data.creationSimpleDays ?? 1
      this.creationMediumDays = data.creationMediumDays ?? 3
      this.creationComplexDays = data.creationComplexDays ?? 5
      // Modification days
      this.modificationSimpleDays = data.modificationSimpleDays ?? 0.5
      this.modificationMediumDays = data.modificationMediumDays ?? 1.5
      this.modificationComplexDays = data.modificationComplexDays ?? 3
      // Deletion days
      this.deletionSimpleDays = data.deletionSimpleDays ?? 0.25
      this.deletionMediumDays = data.deletionMediumDays ?? 0.5
      this.deletionComplexDays = data.deletionComplexDays ?? 1
      // Other properties
      this.typicalPercentage = data.typicalPercentage ?? 0
      this.order = data.order ?? 0
      this.color = data.color
      this.description = data.description
      this.isActive = data.isActive ?? true
      this.defaultHourlyRate = data.defaultHourlyRate ?? 0
      this.isDefaultBillingScale = data.isDefaultBillingScale ?? false
      this.schedulingPhase = enumValue(SchedulingPhase, data.schedulingPhase, SchedulingPhase.Development)
    }
  }

  /**
   * Get the base days for a given CRUD type and complexity level
   */
  getDays(crudType: CrudType, complexity: ComplexityLevel): number {
    if (crudType === CrudType.Creation) {
      switch (complexity) {
        case ComplexityLevel.Simple:
          return this.creationSimpleDays
        case ComplexityLevel.Medium:
          return this.creationMediumDays
        case ComplexityLevel.Complex:
          return this.creationComplexDays
      }
    } else if (crudType === CrudType.Modification) {
      switch (complexity) {
        case ComplexityLevel.Simple:
          return this.modificationSimpleDays
        case ComplexityLevel.Medium:
          return this.modificationMediumDays
        case ComplexityLevel.Complex:
          return this.modificationComplexDays
      }
    } else if (crudType === CrudType.Deletion) {
      switch (complexity) {
        case ComplexityLevel.Simple:
          return this.deletionSimpleDays
        case ComplexityLevel.Medium:
          return this.deletionMediumDays
        case ComplexityLevel.Complex:
          return this.deletionComplexDays
      }
    }
    return this.creationMediumDays
  }
}
